<template>
    <div class="modal fade" id="confirmationCloseHolderCertifie" tabindex="-1" role="dialog" aria-labelledby="confirmationCloseHolderCertifie" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="confirmationModalLabel">{{title}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <div class="modal-body" v-if="order && order.typeOrder!=null" >
                    
                    <h5><strong>{{message}}</strong> </h5><br/>
                    <p v-if="order.systemUser"><strong>{{$t('string.msg.order.type.label.trucker')}}:</strong> {{' ' + $t(order.systemUser.firstName) + ' ' + $t(order.systemUser.lastName)}}</p>
                    <p ><strong>{{$t('string.msg.order.type.label.modal')}}:</strong> {{' ' + $t(order.typeOrder) + ' - ' + order.description}}</p>
                    <p ><strong>{{$t('string.msg.order.type.label.date')}}:</strong> {{' ' + new Date(order.dateOrder).toLocaleDateString()}} - {{new Date(order.dateOrder).toLocaleTimeString()}} </p> 
                    <label for="inputAddress" class="col-form-label">
                        {{$t('response.close.order.justify.msg')}}
                    </label>
                    
                    <input type="text" v-model="order.justifyClose" class="form-control">
                </div>
                
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary"  data-dismiss="modal" v-on:click="$emit('confirmation-return', 0)">{{cancelText}}</button>
                    <button type="button" class="btn btn-primary"  data-dismiss="modal" v-on:click="$emit('confirmation-return', 1)">{{yesText}}</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: ["title", "message", "cancelText", "yesText", "order"],
        watch:{
            'order'(){
                this.order = this.order;
                this.order.justifyClose = this.order.justifyClose;
            }
        },
        data() {
            return {
                order: {}
            }
    },
    methods:{
    }
}
</script>